module.exports = __webpack_public_path__ + "static/media/up-arrow.b729c8f6.svg";